import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between flex-col" }
const _hoisted_2 = { class: "flex space-x-1" }
const _hoisted_3 = { class: "flex space-x-2 relative text-ellipsis truncate w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 right-0 bg-gradient-to-r from-transparent to-brand-black w-14 h-full" }, null, -1)
const _hoisted_5 = { class: "overflow-hidden my-auto" }
const _hoisted_6 = { class: "flex z-50" }
const _hoisted_7 = { class: "my-auto pl-4" }
const _hoisted_8 = { class: "flex border-brand-dark-gray justify-between space-x-1" }
const _hoisted_9 = { class: "flex my-auto space-x-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.52035 14.1598C6.71329 14.1598 7.68035 13.1928 7.68035 11.9998C7.68035 10.8069 6.71329 9.83984 5.52035 9.83984C4.32742 9.83984 3.36035 10.8069 3.36035 11.9998C3.36035 13.1928 4.32742 14.1598 5.52035 14.1598Z",
  fill: "#A5A7AF"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.0008 14.1598C13.1938 14.1598 14.1608 13.1928 14.1608 11.9998C14.1608 10.8069 13.1938 9.83984 12.0008 9.83984C10.8079 9.83984 9.84082 10.8069 9.84082 11.9998C9.84082 13.1928 10.8079 14.1598 12.0008 14.1598Z",
  fill: "#A5A7AF"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.4803 14.1598C19.6732 14.1598 20.6403 13.1928 20.6403 11.9998C20.6403 10.8069 19.6732 9.83984 18.4803 9.83984C17.2874 9.83984 16.3203 10.8069 16.3203 11.9998C16.3203 13.1928 17.2874 14.1598 18.4803 14.1598Z",
  fill: "#A5A7AF"
}, null, -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.52035 14.1598C6.71329 14.1598 7.68035 13.1928 7.68035 11.9998C7.68035 10.8069 6.71329 9.83984 5.52035 9.83984C4.32742 9.83984 3.36035 10.8069 3.36035 11.9998C3.36035 13.1928 4.32742 14.1598 5.52035 14.1598Z",
  fill: "#A5A7AF"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.0008 14.1598C13.1938 14.1598 14.1608 13.1928 14.1608 11.9998C14.1608 10.8069 13.1938 9.83984 12.0008 9.83984C10.8079 9.83984 9.84082 10.8069 9.84082 11.9998C9.84082 13.1928 10.8079 14.1598 12.0008 14.1598Z",
  fill: "#A5A7AF"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.4803 14.1598C19.6732 14.1598 20.6403 13.1928 20.6403 11.9998C20.6403 10.8069 19.6732 9.83984 18.4803 9.83984C17.2874 9.83984 16.3203 10.8069 16.3203 11.9998C16.3203 13.1928 17.2874 14.1598 18.4803 14.1598Z",
  fill: "#A5A7AF"
}, null, -1)
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]

import {computed, PropType, provide, ref} from "vue";
import {FriendUserInterface} from "@/interfaces/FriendUserInterface";
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {actionSheetController, useIonRouter} from "@ionic/vue";
import UserVerificationCheck from "@/components/UserBadges.vue";
import UserAvatar from "@/components/UserAvatar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FriendListItem',
  props: {
  user: {
    type: Object as PropType<FriendUserInterface>,
    required: true
  }
},
  setup(__props) {


const ionRouter = useIonRouter()

const props = __props

const acceptBusy = ref(false)
const rejectBusy = ref(false)

const isBusy = computed(() => {
  return acceptBusy.value || rejectBusy.value
})

const accept = async () => {
  if (isBusy.value || !props.user) return
  acceptBusy.value = true

  await ApiService.User().makeFriendRequest(props.user.id)
  await Observable.emit(ObservableEvent.FriendsChanged)
  acceptBusy.value = false
}
const reject = async () => {
  if (isBusy.value || !props.user) return
  rejectBusy.value = true

  await ApiService.User().rejectFriendRequest(props.user.id)
  await Observable.emit(ObservableEvent.FriendsChanged)
  rejectBusy.value = false
}

const acceptReject = async () => {
  const sheet = await actionSheetController.create({
    buttons: [
      {
        text: 'Accept',
        handler: async () => {
          await actionSheetController.dismiss()
          await accept()
        }
      },
      {
        text: 'Reject',
        handler: async () => {
          await actionSheetController.dismiss()
          await reject()
        }
      },
      {
        text: 'Cancel',
        role: 'cancel',
      }
    ]
  })
  await sheet.present()
}

const viewUserSettings = async () => {
  if (!props.user?.befriended_at) return
  ionRouter.navigate({
    name: 'PineappleFriendsUserSettings',
    params: {userId: props.user?.id},
  }, 'forward', 'push')
}

const viewUserProfile = async () => {
  if (!props.user?.id) return
  ionRouter.navigate({
    name: 'PineappleFriendsUserProfile',
    params: {
      userId: props.user.id
    }
  }, 'forward', 'push')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(UserAvatar, {
        onClick: viewUserProfile,
        user: __props.user
      }, null, 8, ["user"]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            onClick: viewUserProfile,
            class: "text-white font-medium text-lg my-auto line-clamp-1"
          }, _toDisplayString(__props.user.name), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(UserVerificationCheck, {
            class: "my-auto h-4",
            user: __props.user
          }, null, 8, ["user"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _renderSlot(_ctx.$slots, "actions", {}, () => [
              (!__props.user.befriended_at)
                ? (_openBlock(), _createElementBlock("svg", {
                    key: 0,
                    onClick: acceptReject,
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, _hoisted_13))
                : (_openBlock(), _createElementBlock("svg", {
                    key: 1,
                    onClick: viewUserSettings,
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, _hoisted_17))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})